import { Sprint } from '../types';

export const getSprintForDate = (
  date: Date,
  currentSprint: Sprint | null,
  availableSprints: Sprint[] | undefined,
): Sprint | null => {
  if (!availableSprints?.length) return null;

  // First, try to find a sprint where the date falls between start and end dates
  const sprintForDate = availableSprints.find((sprint) => {
    const startDate = new Date(sprint.startDate);
    const endDate = new Date(sprint.endDate);
    return date >= startDate && date <= endDate;
  });

  // If we found a sprint containing the date, return it
  if (sprintForDate) {
    return sprintForDate;
  }

  return currentSprint;
};
